import React from 'react';
import { ComposableDeviceFormProps } from '../../../../components/ComposableDevice/ComposableDeviceForm/ComposableDeviceForm';
import { getPolyglot } from '../../../../i18n';
import { Stack, Typography } from '@mui/material';
import { DeviceForm } from './ComposableDeviceForm/DeviceForm';
import { ImageForm } from './ComposableDeviceForm/ImageForm';
import { DecksForm } from './ComposableDeviceForm/DecksForm';

export const ComposableDeviceForm = (
  props: ComposableDeviceFormProps & { closeAddComposableDevice?: () => void }
) => {
  const {
    formik,
    setValidationSchema,
    validationSchema,
    image,
    logo,
    setImage,
    setLogo,
    closeAddComposableDevice,
  } = props;
  const polyglot = getPolyglot();
  const isEditMode = Boolean(formik.values?.id);

  return (
    <>
      {!isEditMode ? (
        <Typography variant="body2" textAlign={'start'}>
          {polyglot.t('composable_device.add_composable_device_information')}
        </Typography>
      ) : null}
      <form onSubmit={formik.handleSubmit}>
        <Stack
          display="grid"
          gridTemplateColumns={isEditMode ? '1fr' : '1fr 1fr 1fr'}
          gap={1}
          marginTop={2}
        >
          <DeviceForm formik={formik} />
          <DecksForm
            formik={formik}
            setValidationSchema={setValidationSchema}
            validationSchema={validationSchema}
          />
          <ImageForm
            formik={formik}
            setImage={setImage}
            setLogo={setLogo}
            image={image}
            logo={logo}
            closeAddComposableDevice={closeAddComposableDevice}
          />
        </Stack>
      </form>
    </>
  );
};
